// src/components/Home.js
import React from 'react';
import TextBox from './TextBox';
import styled from 'styled-components';
import background from '../assets/background.jpg';

const HomeContainer = styled.div`
  background-image: url(${background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const ContentWrapper = styled.div`
  border-radius: 12px;
  padding: 20px;
  max-width: 800px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
  position: relative;
  perspective: 1000px;
`;

const Home = () => {
  console.log("Home component is rendered");

  return (
    <HomeContainer>
      <ContentWrapper>
        <TextBox>
          <h2>About Me</h2>
          <p>
            I am a software developer currently employed in Manchester, CT. 
            I graduated from Colgate University with a degree in Computer Science. 
            I have experience in full stack development, cloud & devops architecture, RESTful API development and integration. 
            Outside of work, I am a lifelong soccer player and passionate Manchester City fan. 
            I am a musician and have played the bass for about 8 years and viola for over 18 years now. 
            An ideal summer day for me would be going to the turf with friends and then biking to the river. 
            A personal goal of mine is to complete a marathon in the next 3 years. 
          </p>
        </TextBox>

        <TextBox>
          <h2>About the Site</h2>
          <p>
            My main goal in making this site is to learn the React library and experiment with different functionalities. 
            As of 1.4, this site has a home page which consists of an about me and this about the site, a customization page which allows users to adjust the theme of the site, and a contact page which would allow users to submit their name, email, and reason for contact securely to my aws lambda to be stored and accessed by me. 
            Currently, the contact page is not functional as I have stopped payment on my aws account. 
            The site is hosted on netlify and the domain is managed through squarespace. 
            My goal for this site is for it to continue to be an experimental playground for me as I implement more features and projects. 
          </p>
        </TextBox>
      </ContentWrapper>
    </HomeContainer>
  );
};

export default Home;
